import { useMutation, useQueryClient } from '@tanstack/react-query';
import { CheckupTag } from '@companion-professional/dctypes';
import { createCheckupForPetId } from '../lib/api';

type CreateCheckupValues = {
  clinicId: string;
  petId: string;
  tags?: CheckupTag[];
};

// useCreateCheckupForPet is a hook that creates a new checkup for a clinic and a Companion Vision petId.
export const useCreateCheckupForPet = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync: createCheckup,
    isPending,
    error,
    reset
  } = useMutation({
    mutationFn: async ({ clinicId, petId, tags = [] }: CreateCheckupValues) => {
      const res = await createCheckupForPetId(clinicId, petId, tags);
      await queryClient.invalidateQueries({
        queryKey: ['active-checkups']
      });
      await queryClient.invalidateQueries({
        queryKey: ['pet-checkups', petId]
      });
      return res;
    }
  });

  return {
    createCheckup,
    isPending,
    error,
    reset
  };
};
